// export const API_BASE_URL = "http://127.0.0.1:8000/api"; // Change when deployed
export const API_BASE_URL = "https://fithub-app-be.onrender.com/api";

export const API_ENDPOINTS = {
  PRODUCTS: "/products",
  USERS: "/users",
  LOGIN: "/login",
  ORDERS: "/orders",
  CART: "/cart",
  CART_REMOVE: "/cart/remove",
  FAVORITES: "/favorites",
};
